export const CONVERSIONS = {
  directions: "AW-18472739899/SHVNCKuly54dELvIvuhE",
  zomatoOrder: "AW-18472739899/jMkACK6ly54dELvIvuhE",
};

export const reportConversion = (sendTo) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: sendTo });
  }
};
